import type { ColumnProps } from "react-aria-components";

import type { ReactNode } from "react";

import clsx from "clsx";
import { Column } from "react-aria-components";

import { ArrowsSortIcon } from "../../../icons/arrows-sort";

import styles from "./table-column.module.css";

type TableColumnProps = ColumnProps & {
	width?: number;
};

export function TableColumn({ children, width, ...props }: TableColumnProps): ReactNode {
	return (
		<Column {...props} style={{ width }}>
			{(renderProps) => {
				const { allowsSorting, sortDirection } = renderProps;

				return (
					<span className={clsx(styles.content, allowsSorting && styles.sortable)}>
						<span className={styles.label}>
							{typeof children === "function" ? children(renderProps) : children}
						</span>
						{allowsSorting ? (
							<ArrowsSortIcon
								aria-hidden="true"
								className={styles.sortIndicator}
								data-sort-direction={sortDirection}
							/>
						) : null}
					</span>
				);
			}}
		</Column>
	);
}
